/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remaining_TimeInputs */

const en_remaining_time = /** @type {(inputs: Remaining_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remaining Time`)
};

const fr_remaining_time = /** @type {(inputs: Remaining_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temps restant`)
};

const de_remaining_time = /** @type {(inputs: Remaining_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbleibende Zeit`)
};

const it_remaining_time = /** @type {(inputs: Remaining_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo rimanente`)
};

const ru_remaining_time = /** @type {(inputs: Remaining_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оставшееся время`)
};

const es_remaining_time = /** @type {(inputs: Remaining_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiempo restante`)
};

const zh_cn2_remaining_time = /** @type {(inputs: Remaining_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`剩余时间`)
};

const ja_remaining_time = /** @type {(inputs: Remaining_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`残り時間`)
};

const hi_remaining_time = /** @type {(inputs: Remaining_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शेष समय`)
};

const pt_pt2_remaining_time = /** @type {(inputs: Remaining_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo restante`)
};

/**
* | output |
* | --- |
* | "Remaining Time" |
*
* @param {Remaining_TimeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remaining_time = /** @type {((inputs?: Remaining_TimeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remaining_TimeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_remaining_time(inputs)
	if (locale === "de") return de_remaining_time(inputs)
	if (locale === "it") return it_remaining_time(inputs)
	if (locale === "ru") return ru_remaining_time(inputs)
	if (locale === "es") return es_remaining_time(inputs)
	if (locale === "zh-CN") return zh_cn2_remaining_time(inputs)
	if (locale === "ja") return ja_remaining_time(inputs)
	if (locale === "hi") return hi_remaining_time(inputs)
	if (locale === "pt-PT") return pt_pt2_remaining_time(inputs)
	return en_remaining_time(inputs)
});